export default __webpack_public_path__ + "static/tek-logo-video-fd56b3a52edfea51a26c79c55af70b13.webm";